import { parse, stringify } from 'flatted/esm';

export default function reformatRepeaterKeys (metafields) {

    let arr = parse(stringify(metafields))
    return arr.map(item => {

        if (item.type === 'repeater' && item.children.length) {
            
            item.children = item.children.map(item => {
                
                return item.map(subitem => {
                    if(subitem.key.includes('_[i]') && subitem.key.lastIndexOf('__') > -1) {
                        subitem.key = subitem.key.substr(0, subitem.key.lastIndexOf('__'))
                    }

                    return subitem
                })
            })
        }

        if (item.type === 'group' && item.children.length) {
            item.children = reformatRepeaterKeys(item.children)
            
            return item
        }

        return item
    })
}


// WEBPACK FOOTER //
// ./src/helpers/reformat-repeater-keys.js